var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgInactive = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 9c-.552 0-1-.449-1-1 0-.009.002-.017.004-.026l.004-.023 1.041 1.041c-.008 0-.016.002-.024.004S8.008 9 8 9zM3.138 2.195c-.26-.26-.682-.26-.943 0-.26.261-.26.682 0 .943l3.753 3.753c-.184.34-.282.716-.282 1.109 0 1.287 1.047 2.333 2.334 2.333.392 0 .769-.098 1.108-.282l3.754 3.754c.13.13.3.195.471.195.17 0 .341-.065.471-.195.261-.261.261-.682 0-.943L3.138 2.195zm5.008 9.137c-2.87.066-4.743-2.389-5.364-3.335.304-.476.815-1.173 1.522-1.807l-.941-.942c-1.015.926-1.665 1.938-1.941 2.42-.118.206-.118.458 0 .664.419.731 2.686 4.334 6.594 4.334.055 0 .11 0 .164-.002.79-.02 1.504-.19 2.152-.446l-1.054-1.054c-.356.095-.732.158-1.132.168zM7.82 3.336c3.983-.125 6.333 3.59 6.758 4.332.117.206.117.458 0 .664-.276.482-.927 1.494-1.942 2.42l-.94-.942c.706-.634 1.218-1.331 1.521-1.807-.62-.946-2.503-3.407-5.363-3.335-.4.01-.776.073-1.133.168L5.668 3.782c.648-.256 1.362-.426 2.152-.446z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInactive, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/inactive.2a46d370.svg";
export { ForwardRef as ReactComponent };